document.addEventListener('click', e => {
  const card = e.target.closest('.product-card[data-url]');
  if (!card) return;
  if (e.target.closest('a[data-card-link]')) return;
  if (e.target.closest('cdx-card-form')) return;
  if (e.target.closest('cdx-klaviyo-notify-button')) return;
  if (e.target.closest('cdx-klaviyo-notify-popup')) return;
  window.location.href = card.dataset.url;
});

class FooterAccordion extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.accordion-trigger');
    this.content = this.querySelector('.accordion-content');
  }

  connectedCallback() {
    this.button.addEventListener('click', () => {
      if (window.innerWidth >= 750) return;
      const isOpen = this.button.getAttribute('aria-expanded') === 'true';
      isOpen ? this.close() : this.open();
    });
  }

  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.content.style.maxHeight = this.content.scrollHeight + "px";
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.content.style.maxHeight = "0px";
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion);
}

class CdxCardForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.priceDisplay = this.querySelector('.js-price-display');
    this.atcButton = this.querySelector('.js-atc-trigger');
    this.modal = this.querySelector('.js-quickshop-modal');
    this.modalBox = this.modal ? this.modal.querySelector('.relative') : null;

    this.initVariantButtons();
    this.initQuickShopModal();
    this.initAddToCart();
  }

  // Logik für 1 oder 2 Varianten (Aktiviert automatisch die Standardauswahl)
  initVariantButtons() {
    const buttons = this.querySelectorAll('.js-variant-trigger');
    if (buttons.length === 0) return;

    this._hasVariantImages = Array.from(buttons).some(b => b.dataset.mediaSrc);

    buttons.forEach(btn => {
      if (btn.dataset.defaultActive === 'true' || buttons.length === 1) {
        this.setActiveVariant(btn);
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.setActiveVariant(btn);
      });
    });
  }

  setActiveVariant(button) {
    this.querySelectorAll('.js-variant-trigger').forEach(b => {
      b.classList.remove('is-active');
      if (b.dataset.isSwatch) b.style.removeProperty('box-shadow');
    });
    button.classList.add('is-active');
    if (button.dataset.isSwatch) {
      button.style.setProperty('box-shadow', 'inset 0 0 0 2px #76232F', 'important');
    }

    this.querySelectorAll('.js-price-display').forEach(el => el.textContent = button.dataset.variantPrice);
    if (this.atcButton) this.atcButton.dataset.selectedVariantId = button.dataset.variantId;

    const comparePrice = button.dataset.comparePrice;
    this.querySelectorAll('.js-compare-price').forEach(el => {
      if (comparePrice) {
        el.textContent = comparePrice;
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    const discountBadge = this.closest('.product-card')?.querySelector('.js-discount-badge');
    if (discountBadge) {
      const pct = parseInt(button.dataset.discountPercent) || 0;
      if (pct > 0) {
        discountBadge.querySelector('span').textContent = `-${pct}%`;
        discountBadge.classList.remove('hidden');
      } else {
        discountBadge.classList.add('hidden');
      }
    }

    const card = this.closest('.product-card');

    if (button.dataset.variantUrl && card) {
      card.dataset.url = button.dataset.variantUrl;
      card.querySelectorAll('a[data-card-link]').forEach(a => a.href = button.dataset.variantUrl);
    }

    this.applyCardAvailability(button.dataset.variantId, button.dataset.available !== 'false', { hideAtc: true });

    if (this._hasVariantImages) {
      const src = button.dataset.mediaSrc || this.dataset.productMedia;
      const img = card?.querySelector('.js-card-image');
      if (img && src) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }
    }

    const hoverSrc = button.dataset.hoverSrc || '';
    const hoverType = button.dataset.hoverType || '';
    const mainImg = card?.querySelector('.js-card-image');
    const hoverWrapper = card?.querySelector('.js-card-hover-wrapper');
    if (hoverWrapper) {
      const hasHover = !!(hoverSrc && hoverType);
      const prevMedia = hoverWrapper.querySelector('.js-card-hover-media');
      if (prevMedia) prevMedia.remove();

      if (hasHover) {
        const mediaClass = hoverWrapper.dataset.hoverClass || '';
        let el;

        if (hoverType === 'video') {
          hoverWrapper.classList.add('is-loading');
          el = document.createElement('video');
          el.autoplay = true;
          el.loop = true;
          el.muted = true;
          el.setAttribute('playsinline', '');
          const source = document.createElement('source');
          source.src = hoverSrc;
          source.type = 'video/mp4';
          el.appendChild(source);
          el.addEventListener('canplay', () => {
            hoverWrapper.classList.remove('is-loading');
          }, { once: true });
        } else {
          hoverWrapper.classList.remove('is-loading');
          el = document.createElement('img');
          el.src = hoverSrc;
          el.alt = '';
          el.width = 600;
          el.height = 600;
        }
        el.className = mediaClass;
        hoverWrapper.appendChild(el);
      } else {
        hoverWrapper.classList.remove('is-loading');
      }
      if (mainImg) mainImg.classList.toggle('group-hover:opacity-0', hasHover);
    }
  }

  // Notify-Overlay und Dimming auf den Zustand der gewählten Variante bringen.
  // hideAtc: false im Quickshop, damit das Modal erreichbar bleibt.
  applyCardAvailability(variantId, available, { hideAtc = true } = {}) {
    const card = this.closest('.product-card');
    if (!card) return;

    const overlay = card.querySelector('.js-card-notify-overlay');
    if (overlay) {
      overlay.classList.toggle('hidden', available);
      if (!available && variantId) {
        const notifyBtn = overlay.querySelector('cdx-klaviyo-notify-button');
        if (notifyBtn) notifyBtn.dataset.bisId = variantId;
        card.querySelector('.js-card-kl-popup')?.setAttribute('variant', variantId);
      }
    }

    if (hideAtc) {
      card.querySelector('.js-atc-trigger')?.classList.toggle('hidden', !available);
    }
    card.querySelectorAll('.js-card-dimmable-area').forEach(el => el.classList.toggle('opacity-50', !available));
  }

  // Logik für das Quick-Shop Modal (> 2 Varianten)
  initQuickShopModal() {
    if (!this.modal || !this.atcButton) return;

    const firstChecked = this.modal.querySelector('input[type="radio"]:checked');
    if (firstChecked) {
      const s = this.modal.querySelector(`.js-modal-swatch[data-variant-id="${firstChecked.value}"]`);
      if (s) s.style.setProperty('box-shadow', 'inset 0 0 0 2px #76232F', 'important');
      this.syncQuickShopAvailability(firstChecked);
    }

    // Öffnen bei Klick auf den runden Taschen-Button
    this.atcButton.addEventListener('click', (e) => {
      if (this.atcButton.dataset.action === 'open-modal') {
        e.preventDefault();
        this.openModal();
      }
    });

    // Schließen Event-Listener (Kreuz & Overlay)
    const closeBtn = this.querySelector('.js-modal-close');
    const overlay = this.querySelector('.js-modal-close-overlay');

    if (closeBtn) closeBtn.addEventListener('click', () => this.closeModal());
    if (overlay) overlay.addEventListener('click', () => this.closeModal());

    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (this.atcButton) this.atcButton.dataset.selectedVariantId = radio.value;
        this.querySelectorAll('.js-modal-swatch').forEach(s => s.style.removeProperty('box-shadow'));
        const active = this.querySelector(`.js-modal-swatch[data-variant-id="${radio.value}"]`);
        if (active) active.style.setProperty('box-shadow', 'inset 0 0 0 2px #76232F', 'important');
        if (radio.dataset.mediaSrc) {
          const img = this.closest('.product-card')?.querySelector('.js-card-image');
          if (img) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = radio.dataset.mediaSrc;
          }
        }
        this.syncQuickShopAvailability(radio);
      });
    });
  }

  // Quickshop: ausverkaufte Variante -> Card-Overlay aktualisieren und den
  // Modal-Button auf "Benachrichtigen" umstellen. Der runde ATC-Button bleibt
  // sichtbar, sonst käme man nicht mehr ins Modal zurück.
  syncQuickShopAvailability(radio) {
    const available = radio.dataset.available !== 'false';
    this.applyCardAvailability(radio.value, available, { hideAtc: false });

    const submitBtn = this.querySelector('.js-modal-submit');
    if (!submitBtn) return;
    submitBtn.dataset.mode = available ? 'add-to-cart' : 'notify';
    const label = submitBtn.querySelector('.js-btn-text');
    if (label) label.textContent = available ? 'In den Warenkorb' : 'Benachrichtigen';
  }

  openModal() {
    this.modal.classList.remove('pointer-events-none');
    this.modal.style.opacity = '1';
    if (this.modalBox) this.modalBox.style.transform = 'translateY(0)';
  }

  closeModal() {
    this.modal.classList.add('pointer-events-none');
    this.modal.style.opacity = '0';
    if (this.modalBox) this.modalBox.style.transform = 'translateY(100%)';
  }

  // Abschicken an den Shopify-Cart
  initAddToCart() {
    const submitBtn = this.querySelector('.js-modal-submit');

    // Handler für direkten ATC oder Modal-ATC
    const handleAdd = (variantId, triggerBtn) => {
      const cartDrawer = document.querySelector('cart-drawer');
      const spinner = triggerBtn.querySelector('.loading__spinner');
      const icon = triggerBtn.querySelector('.js-atc-icon');
      const btnText = triggerBtn.querySelector('.js-btn-text');

      triggerBtn.disabled = true;
      if (spinner) spinner.classList.remove('hide');
      if (icon) icon.classList.add('hide');
      if (btnText) btnText.classList.add('hide');

      const formData = {
        'items': [{
          'id': parseInt(variantId),
          'quantity': 1
        }]
      };

      if (cartDrawer) {
        formData.sections = cartDrawer.getSectionsToRender().map(s => s.id);
        formData.sections_url = window.location.pathname;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (this.modal && !this.modal.classList.contains('pointer-events-none')) {
          this.closeModal();
        }
        if (cartDrawer) {
           cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        }
      })
      .catch((error) => console.error('Error:', error))
      .finally(() => {
        triggerBtn.disabled = false;
        if (spinner) spinner.classList.add('hide');
        if (icon) icon.classList.remove('hide');
        if (btnText) btnText.classList.remove('hide');
      });
    };

    // Klick auf runden Button (wenn Direktkauf aktiv)
    this.atcButton.addEventListener('click', () => {
      if (this.atcButton.dataset.action === 'add-to-cart') {
        handleAdd(this.atcButton.dataset.selectedVariantId, this.atcButton);
      }
    });

    // Klick auf "In den Warenkorb" im Modal
    if (submitBtn) {
      submitBtn.addEventListener('click', () => {
        const checkedRadio = this.querySelector('input[type="radio"]:checked');
        if (!checkedRadio) return;

        if (submitBtn.dataset.mode === 'notify') {
          const card = this.closest('.product-card');
          const popup = card?.querySelector('.js-card-kl-popup');
          if (popup) {
            popup.setAttribute('variant', checkedRadio.value);
            this.closeModal();
            popup.open();
          }
          return;
        }

        handleAdd(checkedRadio.value, submitBtn);
      });
    }
  }
}

if (!customElements.get('cdx-card-form')) {
  customElements.define('cdx-card-form', CdxCardForm);
}

class CodextLangSwitcher extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('cdx-language-switch', CodextLangSwitcher);

class CdxProductGallery extends HTMLElement {
  connectedCallback() {
    this._slides    = this.querySelectorAll('.gallery-slide');
    this._thumbs    = this.querySelectorAll('.gallery-thumb');
    this._dots      = this.querySelectorAll('.gallery-dot');
    this._thumbList = this.querySelector('.gallery-thumbs-list');
    this._thumbPrev = this.querySelector('.gallery-thumbs-prev');
    this._thumbNext = this.querySelector('.gallery-thumbs-next');
    this._thumbOffset = 0;
    this._THUMB_H    = 75 + 8;
    this._THUMB_PAGE = 6;

    const activeSlide = this.querySelector('.gallery-slide.opacity-100');
    this._current = activeSlide ? parseInt(activeSlide.dataset.index) : 0;
    this._touchStartX = 0;

    this._thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => this._goTo(parseInt(thumb.dataset.index)));
    });
    this._dots.forEach(dot => {
      dot.addEventListener('click', () => this._goTo(parseInt(dot.dataset.index)));
    });

    if (this._thumbPrev) this._thumbPrev.addEventListener('click', () => this._scrollThumbs(-1));
    if (this._thumbNext) this._thumbNext.addEventListener('click', () => this._scrollThumbs(1));
    this._updateThumbNav();

    const main = this.querySelector('.gallery-main');
    if (main) {
      main.addEventListener('touchstart', e => {
        this._touchStartX = e.touches[0].clientX;
      }, { passive: true });
      main.addEventListener('touchend', e => {
        const diff = this._touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          const dir = diff > 0 ? 1 : -1;
          const next = this._nextVisible(this._current, dir);
          if (next !== -1) this._goTo(next);
        }
      });
    }
  }

  goToMedia(mediaId) {
    const slide = this.querySelector(`.gallery-slide[data-media-id="${mediaId}"]`);
    if (slide) this._goTo(parseInt(slide.dataset.index));
  }

  _isHidden(el) {
    return el.classList.contains('hidden!') || el.classList.contains('!hidden');
  }

  filterByVariant(variantId) {
    const id = String(variantId);
    this._slides.forEach(slide => {
      const vid = slide.dataset.variantId;
      const hide = !(!vid || vid === id);
      slide.classList.toggle('hidden!', hide);
      slide.classList.remove('!hidden');
    });
    this._thumbs.forEach(thumb => {
      const vid = thumb.dataset.variantId;
      const hide = !(!vid || vid === id);
      thumb.classList.toggle('hidden!', hide);
      thumb.classList.remove('!hidden');
    });
    this._dots.forEach(dot => {
      const vid = dot.dataset.variantId;
      const hide = !(!vid || vid === id);
      dot.classList.toggle('hidden!', hide);
      dot.classList.remove('!hidden');
    });

    if (this._isHidden(this._slides[this._current])) {
      const first = Array.from(this._slides).findIndex(s => !this._isHidden(s));
      if (first !== -1) this._goTo(first);
    }

    this._thumbOffset = 0;
    if (this._thumbList) this._thumbList.style.transform = '';
    this._updateThumbNav();
  }

  _scrollThumbs(dir) {
    const visible = Array.from(this._thumbs).filter(t => !this._isHidden(t));
    const max = Math.max(0, visible.length - this._THUMB_PAGE);
    this._thumbOffset = Math.max(0, Math.min(max, this._thumbOffset + dir));
    if (this._thumbList) {
      this._thumbList.style.transform = `translateY(-${this._thumbOffset * this._THUMB_H}px)`;
    }
    this._updateThumbNav();
  }

  _updateThumbNav() {
    const visible = Array.from(this._thumbs).filter(t => !this._isHidden(t));
    const max = Math.max(0, visible.length - this._THUMB_PAGE);
    if (this._thumbPrev) {
      this._thumbPrev.classList.toggle('opacity-30', this._thumbOffset === 0);
      this._thumbPrev.classList.toggle('pointer-events-none', this._thumbOffset === 0);
    }
    if (this._thumbNext) {
      this._thumbNext.classList.toggle('opacity-30', this._thumbOffset >= max);
      this._thumbNext.classList.toggle('pointer-events-none', this._thumbOffset >= max);
    }
  }

  _ensureThumbVisible(thumbIndex) {
    const visible = Array.from(this._thumbs).filter(t => !this._isHidden(t));
    const pos = visible.findIndex(t => parseInt(t.dataset.index) === thumbIndex);
    if (pos === -1) return;
    if (pos < this._thumbOffset) {
      this._thumbOffset = pos;
    } else if (pos >= this._thumbOffset + this._THUMB_PAGE) {
      this._thumbOffset = pos - this._THUMB_PAGE + 1;
    } else {
      return;
    }
    if (this._thumbList) {
      this._thumbList.style.transform = `translateY(-${this._thumbOffset * this._THUMB_H}px)`;
    }
    this._updateThumbNav();
  }

  _nextVisible(from, direction) {
    let idx = from + direction;
    while (idx >= 0 && idx < this._slides.length) {
      if (!this._isHidden(this._slides[idx])) return idx;
      idx += direction;
    }
    return -1;
  }

  _slide(i)  { return this.querySelector(`.gallery-slide[data-index="${i}"]`); }
  _thumb(i)  { return this.querySelector(`.gallery-thumb[data-index="${i}"]`); }
  _dot(i)    { return this.querySelector(`.gallery-dot[data-index="${i}"]`); }

  _goTo(index) {
    const target = this._slide(index);
    if (!target || index === this._current) return;
    if (this._isHidden(target)) return;

    const prev = this._slide(this._current);
    if (prev) { prev.classList.add('opacity-0', 'pointer-events-none'); prev.classList.remove('opacity-100'); }

    const prevThumb = this._thumb(this._current);
    if (prevThumb) {
      prevThumb.querySelector('.gallery-thumb-overlay')?.classList.add('hidden');
      prevThumb.style.boxShadow = '0px 0px 5px 0px rgba(0,0,0,0.20)';
    }
    const prevDot = this._dot(this._current);
    if (prevDot) { prevDot.classList.remove('w-[24px]', 'bg-[#76232F]'); prevDot.classList.add('w-[8px]', 'bg-[#D1D1D1]'); }

    this._current = index;

    target.classList.remove('opacity-0', 'pointer-events-none');
    target.classList.add('opacity-100');

    const nextThumb = this._thumb(index);
    if (nextThumb) {
      nextThumb.querySelector('.gallery-thumb-overlay')?.classList.remove('hidden');
      nextThumb.style.boxShadow = 'inset 0 0 0 2px #76232F';
    }
    const nextDot = this._dot(index);
    if (nextDot) { nextDot.classList.add('w-[24px]', 'bg-[#76232F]'); nextDot.classList.remove('w-[8px]', 'bg-[#D1D1D1]'); }

    this._ensureThumbVisible(index);
  }
}

if (!customElements.get('cdx-product-gallery')) {
  customElements.define('cdx-product-gallery', CdxProductGallery);
}

class CdxProductForm extends HTMLElement {
  connectedCallback() {
    this._form = this.querySelector('form');
    this._submitBtn = this._form?.querySelector('[name="add"]');
    this._spinner = this._submitBtn?.querySelector('.js-buybox-spinner');
    this._wording = document.getElementById('buybox_atc_wording');
    this._priceEl = document.getElementById('buybox_atc_price');
    this._comparePriceEl = document.getElementById('buybox_atc_compare_price');

    this._form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this._handleSubmit();
    });
  }

  _handleSubmit() {
    const variantId = this._form.querySelector('input[name="id"]')?.value;
    const sellingPlan = this._form.querySelector('input[name="selling_plan"]')?.value;
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    this._setLoading(true);

    const item = { id: parseInt(variantId), quantity: 1 };
    if (sellingPlan) item.selling_plan = parseInt(sellingPlan);

    const formData = { items: [item] };
    if (cartDrawer) {
      formData.sections = cartDrawer.getSectionsToRender().map(s => s.id);
      formData.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(r => r.json())
    .then(data => {
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      }
    })
    .catch(err => console.error('Error:', err))
    .finally(() => this._setLoading(false));
  }

  _setLoading(loading) {
    if (!this._submitBtn) return;
    this._submitBtn.disabled = loading;
    if (this._spinner) this._spinner.classList.toggle('hidden', !loading);
    if (this._wording) this._wording.classList.toggle('invisible', loading);
    if (this._priceEl) this._priceEl.classList.toggle('invisible', loading);
    if (this._comparePriceEl) this._comparePriceEl.classList.toggle('invisible', loading);
  }
}

if (!customElements.get('cdx-product-form')) {
  customElements.define('cdx-product-form', CdxProductForm);
}

class CdxVariantSelector extends HTMLElement {
  connectedCallback() {
    this._form = this.closest('form');
    this._variantInput = this._form?.querySelector('input[name="id"]');
    this._sellingPlanInput = this._form?.querySelector('input[name="selling_plan"]');
    this._variantRadios = this.querySelectorAll('input[name="size-selection"]');
    this._purchaseTypeRadios = this.querySelectorAll('input[name="purchase-type"]');
    this._subOption = this.querySelector('.js-sub-option');
    this._purchaseTypeGrid = this.querySelector('.js-purchase-type-grid');
    this._purchasePrefs = {};

    const initialVariant = this._checkedVariant();
    if (initialVariant) {
      this._applyVariantPurchaseState(initialVariant, true);
      this._updateAtcPrice();
      this._updateUnitPrice(initialVariant);
      const gallery = document.querySelector('cdx-product-gallery');
      if (gallery) {
        gallery.filterByVariant(initialVariant.value);
        const firstSlide = gallery.querySelector('.gallery-slide[data-index="0"]');
        const firstIsVideo = firstSlide?.dataset.mediaType === 'video' || firstSlide?.dataset.mediaType === 'external_video';
        if (firstIsVideo) {
          gallery.goToMedia(firstSlide.dataset.mediaId);
        } else if (initialVariant.dataset.mediaId) {
          gallery.goToMedia(initialVariant.dataset.mediaId);
        }
      }
    } else if (this._purchaseTypeRadios.length > 0) {
      // Default-Variante mit Abo-Option: Selling Plan syncen und Preis/Wording setzen
      this._syncSellingPlan();
      this._updateAtcPriceFromCards();
    }

    this._variantRadios.forEach(r => r.addEventListener('change', () => this._onVariantChange()));
    this._purchaseTypeRadios.forEach(r => r.addEventListener('change', () => this._onPurchaseTypeChange()));
  }

  _checkedVariant() {
    return this.querySelector('input[name="size-selection"]:checked');
  }

  _checkedPurchaseType() {
    return this.querySelector('input[name="purchase-type"]:checked');
  }

  _syncSellingPlan() {
    const pt = this._checkedPurchaseType();
    if (this._sellingPlanInput && pt) {
      this._sellingPlanInput.value = pt.dataset.type === 'subscription' ? pt.value : '';
    }
  }

  _updateAtcPriceFromCards() {
    const pt = this._checkedPurchaseType();
    const isSubscription = pt?.dataset.type === 'subscription';
    const atcWording = document.getElementById('buybox_atc_wording');
    if (atcWording) atcWording.textContent = isSubscription ? 'Jetzt im Abo kaufen' : 'In den Warenkorb';
    const atcPrice = document.getElementById('buybox_atc_price');
    if (atcPrice) {
      const subPriceEl = document.getElementById('js-sub-price');
      const oncePriceEl = document.getElementById('js-once-price');
      if (isSubscription && subPriceEl) atcPrice.textContent = subPriceEl.textContent.trim();
      else if (!isSubscription && oncePriceEl) atcPrice.textContent = oncePriceEl.textContent.trim();
    }
  }

  _updateAtcPrice() {
    const variant = this._checkedVariant();
    const pt = this._checkedPurchaseType();
    if (!variant) return;

    const isSubscription = pt?.dataset.type === 'subscription';
    const price = isSubscription ? variant.dataset.subPrice : variant.dataset.price;
    const atcPrice = document.getElementById('buybox_atc_price');
    if (atcPrice) atcPrice.textContent = price;

    const comparePrice = document.getElementById('buybox_atc_compare_price');
    if (comparePrice) {
      const cp = variant.dataset.comparePrice;
      if (cp) {
        comparePrice.textContent = cp;
        comparePrice.classList.remove('hidden');
      } else {
        comparePrice.textContent = '';
        comparePrice.classList.add('hidden');
      }
    }

    const atcWording = document.getElementById('buybox_atc_wording');
    if (atcWording) atcWording.textContent = isSubscription ? 'Jetzt im Abo kaufen' : 'In den Warenkorb';
  }

  _applyVariantPurchaseState(variant, initial = false) {
    const hasSellingPlan = variant.dataset.hasSellingPlan === 'true';

    if (this._subOption) this._subOption.hidden = !hasSellingPlan;
    if (this._purchaseTypeGrid) {
      this._purchaseTypeGrid.classList.toggle('grid-cols-2', hasSellingPlan);
      this._purchaseTypeGrid.classList.toggle('grid-cols-1', !hasSellingPlan);
    }

    const savedPref = this._purchasePrefs[variant.value];
    let targetType;
    if (!hasSellingPlan) {
      targetType = 'once';
    } else if (savedPref) {
      targetType = savedPref;
    } else if (initial) {
      // respect what Liquid rendered (subscription radio has checked attr)
      targetType = this._checkedPurchaseType()?.dataset.type || 'subscription';
    } else {
      targetType = 'subscription';
    }

    this._purchaseTypeRadios.forEach(r => {
      r.checked = r.dataset.type === targetType;
    });

    this._syncSellingPlan();
  }

  _onVariantChange() {
    const variant = this._checkedVariant();
    if (!variant) return;

    if (this._variantInput) this._variantInput.value = variant.value;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    history.replaceState({}, '', url.toString());

    const subStrike = document.getElementById('js-sub-strike-price');
    const subPrice = document.getElementById('js-sub-price');
    const oncePrice = document.getElementById('js-once-price');
    const unitPrice = document.getElementById('buybox_unit_price');

    if (subStrike) subStrike.textContent = variant.dataset.price;
    if (subPrice) subPrice.textContent = variant.dataset.subPrice;
    const discountBadge = document.getElementById('buybox_sub_discount');
    if (discountBadge && variant.dataset.subDiscount) discountBadge.textContent = `- ${variant.dataset.subDiscount} %`;
    if (oncePrice) oncePrice.textContent = variant.dataset.price;
    const colorLabel = document.getElementById('buybox_color_label');
    if (colorLabel && variant.dataset.optionValue) colorLabel.textContent = variant.dataset.optionValue;

    const gallery = document.querySelector('cdx-product-gallery');
    if (gallery) {
      gallery.filterByVariant(variant.value);
      if (variant.dataset.mediaId) gallery.goToMedia(variant.dataset.mediaId);
    }

    this._applyVariantPurchaseState(variant);
    this._updateAtcPrice();
    this._updateUnitPrice(variant);
    this._updateBenefits();
    this._updateAvailability(variant);
    this._updateDiscountBadge(variant);
  }

  _updateDiscountBadge(variant) {
    const badge = document.querySelector('[id^="pdp-discount-badge-"]');
    if (!badge) return;
    const pct = parseInt(variant.dataset.discountPercent || '0', 10);
    if (pct > 0) {
      badge.querySelector('span').textContent = `-${pct}%`;
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }
  }

  _onPurchaseTypeChange() {
    const variant = this._checkedVariant();
    const pt = this._checkedPurchaseType();
    if (variant && pt) this._purchasePrefs[variant.value] = pt.dataset.type;
    this._syncSellingPlan();
    if (variant) {
      this._updateAtcPrice();
      this._updateUnitPrice(variant);
    } else {
      this._updateAtcPriceFromCards();
    }
    this._updateBenefits();
  }

  _updateUnitPrice(variant) {
    const unitPrice = document.getElementById('buybox_unit_price');
    if (!unitPrice) return;
    const pt = this._checkedPurchaseType();
    const isSubscription = pt?.dataset.type === 'subscription';
    const price = isSubscription ? variant.dataset.subUnitPrice : variant.dataset.unitPrice;
    if (price) {
      unitPrice.textContent = price;
      unitPrice.classList.remove('hidden');
    } else {
      unitPrice.textContent = '';
      unitPrice.classList.add('hidden');
    }
  }

  _updateAvailability(variant) {
    const available = variant.dataset.available === 'true';
    const atcBtn = document.getElementById('buybox-atc-btn');
    const notifyWrapper = document.getElementById('buybox-notify-wrapper');
    if (atcBtn) atcBtn.classList.toggle('hidden', !available);
    if (notifyWrapper) {
      notifyWrapper.classList.toggle('hidden', available);
      if (!available) {
        const variantId = variant.value;
        const notifyBtn = notifyWrapper.querySelector('cdx-klaviyo-notify-button');
        const notifyPopup = notifyWrapper.querySelector('cdx-klaviyo-notify-popup');
        if (notifyBtn) {
          notifyBtn.dataset.bisId = variantId;
          notifyBtn.setAttribute('for', `klaviyo-popup-${variantId}`);
        }
        if (notifyPopup) {
          notifyPopup.setAttribute('variant', variantId);
          notifyPopup.id = `klaviyo-popup-${variantId}`;
        }
      }
    }
  }

  _updateBenefits() {
    const list = document.getElementById('buybox_benefits_communication');
    if (!list) return;

    const variant = this._checkedVariant();
    const pt = this._checkedPurchaseType();
    if (!variant) return;

    const isSubscription = pt?.dataset.type === 'subscription';
    const raw = isSubscription ? variant.dataset.benefitsSub : variant.dataset.benefitsOnce;
    let items = [];
    try { items = JSON.parse(raw || '[]'); } catch (_) {}

    list.innerHTML = items.map(b => `<li class="text-sm font-medium list-disc list-inside">${b}</li>`).join('');
  }
}

if (!customElements.get('cdx-variant-selector')) {
  customElements.define('cdx-variant-selector', CdxVariantSelector);
}

class CdxAtcBtn extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this._handleClick();
    });
  }

  _handleClick() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this._setLoading(true);

    const cartDrawer = document.querySelector('cart-drawer');
    const item = { id: parseInt(variantId), quantity: 1 };
    if (this.dataset.sellingPlan) item.selling_plan = parseInt(this.dataset.sellingPlan);

    const formData = { items: [item] };
    if (cartDrawer) {
      formData.sections = cartDrawer.getSectionsToRender().map(s => s.id);
      formData.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(r => r.json())
    .then(data => {
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      }
    })
    .catch(err => console.error('Error:', err))
    .finally(() => this._setLoading(false));
  }

  _setLoading(loading) {
    this.toggleAttribute('loading', loading);
    this.style.pointerEvents = loading ? 'none' : '';
    const spinner = this.querySelector('.js-atc-spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
    const content = this.querySelector('.js-atc-content');
    if (content) content.classList.toggle('invisible', loading);
  }
}

if (!customElements.get('cdx-atc-btn')) {
  customElements.define('cdx-atc-btn', CdxAtcBtn);
}

class CdxKlaviyoNotifyPopup extends HTMLElement {
  constructor() {
    super();
  }
  open() {
    this.reset();
    this.classList.add("active");
  }
  close() {
    this.classList.remove("active");
  }
  reset() {
    this.querySelector(".klaviyo-popup-card")?.classList.remove("klaviyo_erfolgreich");
    this.querySelector(".klaviyo-content")?.classList.remove("hidden");
    this.querySelector(".klaviyo-success")?.classList.add("hidden");
    this.querySelector(".klaviyo-error")?.classList.add("hidden");
  }
  successCallback(result) {
    const content = this.querySelector(".klaviyo-content");
    const success = this.querySelector(".klaviyo-success");
    const element = this.querySelector(".klaviyo-popup-card");
    element.classList.add("klaviyo_erfolgreich");
    content.classList.add("hidden");
    success.classList.remove("hidden");
  }
  errorCallback(error) {
    const content = this.querySelector(".klaviyo-content");
    const error_display = this.querySelector(".klaviyo-error");
    content.classList.add("hidden");
    error_display.classList.remove("hidden");
  }
  submit(email, variant) {
    const that = this;
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: `${email}`,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SNvxEX", options)
      .then((response) => {
        // Klaviyo antwortet mit 202 bei Erfolg - ein 4xx darf nicht als Erfolg durchgehen
        if (!response.ok) {
          return response.text().then((body) => {
            throw new Error(`Klaviyo ${response.status}: ${body}`);
          });
        }
        return response;
      })
      .then((result) => that.successCallback(result))
      .catch((error) => that.errorCallback(error));
  }
  connectedCallback() {
    this.emailInput = this.querySelector(".klaviyo-email-input");
    this.submitButton = this.querySelector(".klaviyo-email-submit");
    this.closeButton = this.querySelector(".klaviyo-close");
    this.content = this.querySelector(".klaviyo-popup-card");
    this.addEventListener("click", (event) => {
      if (!this.content.contains(event.target)) {
        this.close();
      }
    });
    if (!!this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        this.close();
      });
    }
    if (!this.emailInput || !this.submitButton) return;

    this.submitButton.addEventListener("click", (event) => {
      if (!this.emailInput.validity.valid) {
        alert("Email invalid");
        return;
      }
      const email = this.emailInput.value;
      // Variante erst beim Klick lesen - sie aendert sich beim Variantenwechsel
      const variant = this.getAttribute("variant");
      if (!email) return;
      if (!variant) {
        this.errorCallback(new Error("missing variant"));
        return;
      }
      this.submit(email, variant);
    });
  }
}
if(!customElements.get("cdx-klaviyo-notify-popup")) {
  customElements.define("cdx-klaviyo-notify-popup", CdxKlaviyoNotifyPopup);
}


class CdxKlaviyoNotifyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const popup_id = !!this.getAttribute("for") ? this.getAttribute("for") : null;
    this.addEventListener("click", (event) => {
      // Popup erst beim Klick suchen: die id kann sich beim Variantenwechsel aendern
      const popup = document.getElementById(this.getAttribute("for") || popup_id);
      if (!popup || typeof popup.open !== "function") return;
      popup.open();
    });
  }
}
if(!customElements.get("cdx-klaviyo-notify-button")) {
  customElements.define("cdx-klaviyo-notify-button", CdxKlaviyoNotifyButton);
}

// Scroll fade-in for .cdx-fade-section elements
(function () {
  function initFadeInSections() {
    var els = document.querySelectorAll('.cdx-fade-section:not(.cdx-fade-observed)');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cdx-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      el.classList.add('cdx-fade-observed');
      observer.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', initFadeInSections);
  document.addEventListener('shopify:section:load', initFadeInSections);
})();

